import React, { useEffect, useState } from "react";

import { Button, Icon, Modal, Radio } from "semantic-ui-react";

import { AppointmentHandleMethodType, METHOD_OPTIONS } from "./sequence/ScheduleSetting";

type ModAppHandleMethodProps = {
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  onSave: (selectedMethod: AppointmentHandleMethodType) => void;
};

const ModAppHandleMethod: React.FC<ModAppHandleMethodProps> = (props) => {
  const [selectedMethod, setSelectedMethod] = useState<"" | AppointmentHandleMethodType>("");

  useEffect(() => {
    if (props.open) {
      setSelectedMethod("");
    }
  }, [props.open]);

  const handleSave = () => {
    if (selectedMethod) {
      props.onSave(selectedMethod);
    }
  };

  return (
    <Modal
      style={{ border: "1px solid rgba(243, 130, 160, 1)", borderRadius: "6px", width: "27.5rem" }}
      open={props.open}
    >
      <div style={{ padding: "1.5rem" }}>
        <div
          style={{ display: "flex", justifyContent: "flex-end", margin: "-0.5rem -0.75rem 0 0" }}
        >
          <Icon
            style={{ color: "rgba(79, 79, 79, 1)", cursor: "pointer", fontSize: "1.15rem" }}
            name="close"
            link
            onClick={props.onClose}
          />
        </div>

        <div
          style={{
            color: "rgba(200, 85, 120, 1)",
            lineHeight: 1.75,
            marginBottom: "1.5rem",
            textAlign: "center",
          }}
        >
          <div>Changing service hours may affect provider</div>
          <div>schedules and currently booking.</div>
          <div style={{ marginTop: "0.5rem" }}>How would you like the system to proceed?</div>
        </div>

        <div style={{ color: "rgba(101, 101, 101, 1)", margin: "1rem 0 1.5rem 1.5rem" }}>
          {METHOD_OPTIONS.map((option, index) => (
            <div
              key={option.value}
              style={{ marginBottom: index < METHOD_OPTIONS.length - 1 ? "1.25rem" : "0" }}
            >
              <Radio
                checked={selectedMethod === option.value}
                label={option.label}
                name="handleMethod"
                value={option.value}
                onChange={() => setSelectedMethod(option.value)}
              />
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
          <Button
            style={{ backgroundColor: "var(--primary-theme-color)", color: "white" }}
            disabled={!selectedMethod}
            loading={props.loading}
            size="small"
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ModAppHandleMethod.displayName = "ModAppHandleMethod";

export default React.memo(ModAppHandleMethod);
